import "core-js/modules/es.function.name.js";
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue";
import _imports_0 from '../image/corporate_icon01.png';
import _imports_1 from '../image/corporate_icon02.png';
import _imports_2 from '../image/corporate_icon03.png';
import _imports_3 from '../image/corporate_icon04.png';
import _imports_4 from '../image/corporate_icon05.png';
var _hoisted_1 = {
  class: "contact_us_box"
};
var _hoisted_2 = {
  class: "contact_box container"
};

var _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", {
  class: "title"
}, "加入我们", -1);

var _hoisted_4 = ["onClick"];
var _hoisted_5 = {
  class: "job_title"
};
var _hoisted_6 = {
  class: "job_text"
};
var _hoisted_7 = {
  class: "job_text"
};
var _hoisted_8 = {
  class: "job_text"
};

var _hoisted_9 = /*#__PURE__*/_createElementVNode("div", {
  class: "job_text"
}, "发布时间：2017/09/28", -1);

var _hoisted_10 = {
  class: "job_text_btn"
};
var _hoisted_11 = {
  class: "contact_bg_box"
};

var _hoisted_12 = /*#__PURE__*/_createElementVNode("div", {
  class: "leaveMessage container"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "leave_line"
}), /*#__PURE__*/_createElementVNode("div", {
  class: "leave_title"
}, "在线留言")], -1);

var _hoisted_13 = {
  class: "leave_input container"
};

var _hoisted_14 = /*#__PURE__*/_createElementVNode("span", {
  class: "xing"
}, "*", -1);

var _hoisted_15 = /*#__PURE__*/_createElementVNode("span", {
  class: "xing"
}, "*", -1);

var _hoisted_16 = /*#__PURE__*/_createElementVNode("span", {
  class: "xing"
}, "*", -1);

var _hoisted_17 = /*#__PURE__*/_createElementVNode("div", {
  class: "up_btn"
}, "立即提交", -1);

var _hoisted_18 = {
  class: "contact_us container"
};

var _hoisted_19 = /*#__PURE__*/_createElementVNode("div", {
  class: "contact_us_img"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "contact_us_big_text"
}, "联系我们")], -1);

var _hoisted_20 = {
  class: "contact_us_left col-lg-5 col-md-5 col-sm-12 col-xs-12"
};
var _hoisted_21 = {
  class: "corporate_name"
};
var _hoisted_22 = {
  class: "corporate_box"
};

var _hoisted_23 = /*#__PURE__*/_createElementVNode("div", {
  class: "corporate_icon_box"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "corporate_icon01"
})], -1);

var _hoisted_24 = {
  class: "corporate_text"
};
var _hoisted_25 = {
  class: "corporate_box"
};

var _hoisted_26 = /*#__PURE__*/_createElementVNode("div", {
  class: "corporate_icon_box"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "corporate_icon02"
})], -1);

var _hoisted_27 = {
  class: "corporate_text"
};
var _hoisted_28 = {
  class: "corporate_box"
};

var _hoisted_29 = /*#__PURE__*/_createElementVNode("div", {
  class: "corporate_icon_box"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "corporate_icon03"
})], -1);

var _hoisted_30 = {
  class: "corporate_text"
};
var _hoisted_31 = {
  class: "corporate_box"
};

var _hoisted_32 = /*#__PURE__*/_createElementVNode("div", {
  class: "corporate_icon_box"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "corporate_icon04"
})], -1);

var _hoisted_33 = {
  class: "corporate_text"
};
var _hoisted_34 = {
  class: "corporate_box"
};

var _hoisted_35 = /*#__PURE__*/_createElementVNode("div", {
  class: "corporate_icon_box"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  class: "corporate_icon05"
})], -1);

var _hoisted_36 = {
  class: "corporate_text"
};

var _hoisted_37 = /*#__PURE__*/_createElementVNode("div", {
  class: "contact_us_right col-lg-7 col-md-7 col-sm-12 col-xs-12"
}, null, -1);

var _hoisted_38 = /*#__PURE__*/_createTextVNode("Click to upload");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_swiper_slide = _resolveComponent("swiper-slide");

  var _component_swiper = _resolveComponent("swiper");

  var _component_MiniPagination = _resolveComponent("MiniPagination");

  var _component_el_input = _resolveComponent("el-input");

  var _component_el_form_item = _resolveComponent("el-form-item");

  var _component_el_form = _resolveComponent("el-form");

  var _component_el_button = _resolveComponent("el-button");

  var _component_el_upload = _resolveComponent("el-upload");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createVNode(_component_swiper, {
    ref: "swiperInstance",
    class: "",
    loop: _ctx.swiper_option.loop,
    speed: _ctx.swiper_option.speed,
    simulateTouch: false,
    slidesPerView: _ctx.swiper_option.showNum,
    slidesPerGroup: _ctx.swiper_option.showNum,
    onSwiper: _ctx.onSwiper
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jboList, function (item, index) {
        return _openBlock(), _createBlock(_component_swiper_slide, {
          class: "'swiper-no-swiping",
          key: item.id
        }, {
          default: _withCtx(function () {
            return [_createElementVNode("div", {
              class: "job_item",
              onClick: function onClick($event) {
                return _ctx.jobSelect(index);
              }
            }, [_createElementVNode("div", {
              class: _normalizeClass(['job_box', _ctx.selectIndex == index ? 'job_box_bg' : ''])
            }, [_createElementVNode("div", _hoisted_5, _toDisplayString(item.jobTitle), 1), _createElementVNode("div", {
              class: _normalizeClass(['job_line', _ctx.selectIndex == index ? 'job_line_bg' : ''])
            }, null, 2), _createElementVNode("div", _hoisted_6, "工作地点：" + _toDisplayString(item.workPlace), 1), _createElementVNode("div", _hoisted_7, "招聘人数：" + _toDisplayString(item.recruitNum), 1), _createElementVNode("div", _hoisted_8, "学历要求：" + _toDisplayString(item.jobEducation), 1), _hoisted_9, _withDirectives(_createElementVNode("div", _hoisted_10, "投递简历", 512), [[_vShow, index === _ctx.selectIndex]])], 2)], 8, _hoisted_4)];
          }),
          _: 2
        }, 1024);
      }), 128))];
    }),
    _: 1
  }, 8, ["loop", "speed", "slidesPerView", "slidesPerGroup", "onSwiper"]), _createVNode(_component_MiniPagination, {
    onPageChanged: _ctx.currentPage,
    total: _ctx.jboList.length,
    pageSize: _ctx.swiper_option.showNum
  }, null, 8, ["onPageChanged", "total", "pageSize"])])]), _createElementVNode("div", _hoisted_11, [_hoisted_12, _createElementVNode("div", _hoisted_13, [_createVNode(_component_el_form, {
    ref: "formRef",
    model: _ctx.messageForm,
    "label-width": "auto",
    class: "demo-ruleForm"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_form_item, {
        class: "col-lg-4 col-md-4 col-sm-6 col-xs-12",
        label: "",
        prop: "name",
        "require-asterisk-position": "right",
        "hide-required-asterisk": false,
        rules: _ctx.rules.name
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_input, {
            modelValue: _ctx.messageForm.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
              return _ctx.messageForm.name = $event;
            }),
            type: "text",
            autocomplete: "off",
            placeholder: "您的姓名"
          }, null, 8, ["modelValue"]), _hoisted_14];
        }),
        _: 1
      }, 8, ["rules"]), _createVNode(_component_el_form_item, {
        class: "col-lg-4 col-md-4 col-sm-6 col-xs-12",
        label: "",
        prop: "phone",
        rules: _ctx.rules.phone
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_input, {
            modelValue: _ctx.messageForm.phone,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
              return _ctx.messageForm.phone = $event;
            }),
            type: "text",
            autocomplete: "off",
            placeholder: "您的电话"
          }, null, 8, ["modelValue"]), _hoisted_15];
        }),
        _: 1
      }, 8, ["rules"]), _createVNode(_component_el_form_item, {
        class: "col-lg-4 col-md-4 col-sm-6 col-xs-12",
        label: "",
        prop: "phone",
        rules: _ctx.rules.email
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_input, {
            modelValue: _ctx.messageForm.email,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
              return _ctx.messageForm.email = $event;
            }),
            type: "text",
            autocomplete: "off",
            placeholder: "您的邮箱"
          }, null, 8, ["modelValue"]), _hoisted_16];
        }),
        _: 1
      }, 8, ["rules"]), _createVNode(_component_el_form_item, {
        class: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
        prop: "pdf"
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", {
            class: "up_notes",
            onClick: _cache[3] || (_cache[3] = function () {
              return _ctx.upNotesClk && _ctx.upNotesClk.apply(_ctx, arguments);
            })
          }, "点击上传简历")];
        }),
        _: 1
      }), _createVNode(_component_el_form_item, {
        class: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
      }, {
        default: _withCtx(function () {
          return [_hoisted_17];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["model"])]), _createElementVNode("div", _hoisted_18, [_hoisted_19, _createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.contactUsInfo.companyName), 1), _createElementVNode("div", _hoisted_22, [_hoisted_23, _createElementVNode("div", _hoisted_24, " 地址:" + _toDisplayString(_ctx.contactUsInfo.companyAddress), 1)]), _createElementVNode("div", _hoisted_25, [_hoisted_26, _createElementVNode("div", _hoisted_27, "热线：" + _toDisplayString(_ctx.contactUsInfo.companyHotPhone), 1)]), _createElementVNode("div", _hoisted_28, [_hoisted_29, _createElementVNode("div", _hoisted_30, "邮编：" + _toDisplayString(_ctx.contactUsInfo.companyPostCode), 1)]), _createElementVNode("div", _hoisted_31, [_hoisted_32, _createElementVNode("div", _hoisted_33, "总机：" + _toDisplayString(_ctx.contactUsInfo.companyMainPhone), 1)]), _createElementVNode("div", _hoisted_34, [_hoisted_35, _createElementVNode("div", _hoisted_36, "邮箱：" + _toDisplayString(_ctx.contactUsInfo.companyEmail), 1)])]), _hoisted_37])]), _createVNode(_component_el_upload, {
    "file-list": _ctx.fileList,
    "onUpdate:file-list": _cache[4] || (_cache[4] = function ($event) {
      return _ctx.fileList = $event;
    }),
    class: "upload-demo",
    action: "https://run.mocky.io/v3/9d059bf9-4660-45f2-925d-ce80ad6c4d15",
    "on-change": _ctx.handleChange
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_button, {
        ref: "upLoadBtn",
        type: "primary"
      }, {
        default: _withCtx(function () {
          return [_hoisted_38];
        }),
        _: 1
      }, 512)];
    }),
    _: 1
  }, 8, ["file-list", "on-change"])], 64);
}